import React from 'react';
import {
  People as PeopleIcon,
  Autorenew as RenewalIcon,
  CreditCard as CreditCardIcon,
} from '@mui/icons-material';
import TabHub from '../../components/layout/TabHub';
import ClientsPage from '../clients/ClientsPage';
import RenewalsPage from '../renewals/RenewalsPage';
import SubscriptionsPage from '../admin/SubscriptionsPage';

// Hub de Clientes: cartera, renovaciones y suscripciones (ciclo de vida del cliente).
const ClientesHub: React.FC = () => (
  <TabHub
    tabs={[
      { key: 'clientes', label: 'Clientes', icon: <PeopleIcon />, element: <ClientsPage /> },
      { key: 'renovaciones', label: 'Renovaciones', icon: <RenewalIcon />, element: <RenewalsPage /> },
      { key: 'suscripciones', label: 'Suscripciones', icon: <CreditCardIcon />, element: <SubscriptionsPage /> },
    ]}
  />
);

export default ClientesHub;
